'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _config = require('./config');

module.exports = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config;

  var next = {};
  var breaks = [null].concat(_toConsumableArray(config.breakpoints));
  var styles = breaks.map(function (b) {
    return {};
  });

  var parsed = shorthands(props);

  var _loop = function _loop(key) {
    var val = parsed[key];
    if (!AXS_REG.test(key)) {
      next[key] = val;
      return 'continue';
    }

    var sx = parsers[key.charAt(0)];

    getVal(sx(config))(val).forEach(function (v, i) {
      styles[i][key] = v;
    });
  };

  for (var key in parsed) {
    var _ret = _loop(key);

    if (_ret === 'continue') continue;
  }

  next.css = styles.reduce(function (a, b, i) {
    return Object.keys(b).length ? Object.assign(a, breaks[i] ? _defineProperty({}, breaks[i], b) : b) : a;
  }, props.css || {});

  if (!Object.keys(next.css).length) delete next.css;

  return next;
};

var AXS_REG = /^(width|padding|margin|fontSize)/;
var SH_REG = /^[wmpf][trblxy]?-?[0-9]?$/;
var shorthands = function shorthands(props) {
  var next = {};

  var _loop2 = function _loop2(key) {
    var val = props[key];
    if (!SH_REG.test(key)) {
      next[key] = val;
      return 'continue';
    }

    var type = key.charAt(0);
    var prop = properties[type];
    var d = key.charAt(1);
    var dirs = directions[d] || [''];
    var n = val === true ? bval(key) : val;

    dirs.forEach(function (dir) {
      next[prop + dir] = n;
    });
  };

  for (var key in props) {
    var _ret2 = _loop2(key);

    if (_ret2 === 'continue') continue;
  }
  return next;
};

var properties = {
  w: 'width',
  m: 'margin',
  p: 'padding',
  f: 'fontSize'
};

var directions = {
  t: ['Top'],
  r: ['Right'],
  b: ['Bottom'],
  l: ['Left'],
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};

var getVal = function getVal(sx) {
  return function (val) {
    return Array.isArray(val) ? val.map(function (v) {
      return v === null ? null : sx(v);
    }) : [sx(val)];
  };
};

var num = function num(n) {
  return typeof n === 'number' && !isNaN(n);
};
var wx = function wx(config) {
  return function (n) {
    return !num(n) ? n : n > 1 ? n : n * 100 + '%';
  };
};
var fx = function fx(config) {
  return function (val) {
    return config.typeScale[val] || val;
  };
};
var mpx = function mpx(config) {
  return function (val) {
    if (!num(val)) return val;
    var neg = val < 0;
    var i = Math.abs(val);
    return (config.space[i] || i) * (neg ? -1 : 1);
  };
};

var parsers = {
  w: wx,
  f: fx,
  m: mpx,
  p: mpx
};

var bval = function bval(key) {
  return parseInt(key.replace(/^[mpf][trblxy]?/, ''));
};


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/parse.js
// module id = 54
// module chunks = 0